import { useCallback } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

export type TaskProjectView = "board" | "backlog" | "roadmap" | "issues" | "releases";

export function useTasksLocation() {
  const params = useParams<{ projectId?: string; "*"?: string }>();
  const [search, setSearch] = useSearchParams();
  const navigate = useNavigate();
  const projectId = params.projectId ?? null;
  const detail = params["*"] ?? "";
  const issueId = detail.startsWith("issues/") ? detail.slice("issues/".length) : null;
  const boardId = search.get("board");
  const requestedView = search.get("view");
  const view: TaskProjectView = requestedView === "backlog" || requestedView === "roadmap" || requestedView === "issues" || requestedView === "releases" ? requestedView : "board";

  const showBoard = useCallback((nextBoardId: string) => {
    setSearch((current) => {
      const updated = new URLSearchParams(current);
      updated.set("board", nextBoardId);
      updated.delete("panel");
      return updated;
    });
  }, [setSearch]);

  const showIssue = useCallback((nextIssueId: string | null) => {
    if (!projectId) return;
    const suffix = search.toString();
    navigate(`${nextIssueId ? `/tasks/${projectId}/issues/${nextIssueId}` : `/tasks/${projectId}`}${suffix ? `?${suffix}` : ""}`);
  }, [navigate, projectId, search]);

  const showView = useCallback((nextView: TaskProjectView) => {
    setSearch((current) => {
      const updated = new URLSearchParams(current);
      if (nextView === "board") updated.delete("view");
      else updated.set("view", nextView);
      return updated;
    });
  }, [setSearch]);

  return { projectId, boardId, issueId, view, showBoard, showIssue, showView };
}
